// extracted by mini-css-extract-plugin
export default {"termOfUse":"TermsOfUse_termOfUse__N2KbY","termOfUse__num":"TermsOfUse_termOfUse__num__w-LXY","termOfUse__lastBlock":"TermsOfUse_termOfUse__lastBlock__ehk8q"};